// Design system matching RevenueSocial website
export const theme = {
  colors: {
    primary: '#1F2937', // Dark slate for good contrast
    secondary: '#8B5CF6', // Purple (secondary brand color)
    accent: '#FFFFFF', // White for strong contrast against gradient
    background: 'linear-gradient(135deg, #1DB584 0%, #8B5CF6 100%)', // Teal to purple gradient
    surface: '#FFFFFF', // White surfaces
    text: {
      primary: '#1F2937', // Dark text for light backgrounds
      secondary: '#4B5563', // Medium gray text
      light: '#6B7280', // Light gray text
      inverse: '#FFFFFF' // White text for dark/gradient backgrounds
    },
    border: '#E5E7EB',
    success: '#10D07A', // Green accent
    error: '#EF4444',
    warning: '#F59E0B',
    // Additional button colors for better contrast
    buttonPrimary: '#1F2937', // Dark slate
    buttonSecondary: '#F3F4F6', // Light gray background
    buttonAccent: '#10D07A', // Green
    // Additional gradient colors
    gradientStart: '#1DB584', // Teal
    gradientEnd: '#8B5CF6'    // Purple
  },
  
  typography: {
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
    sizes: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      '2xl': '24px',
      '3xl': '30px',
      '4xl': '36px',
      '5xl': '48px',
      '6xl': '60px'
    },
    weights: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    },
    lineHeights: {
      tight: 1.2,
      normal: 1.5,
      relaxed: 1.75
    }
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '48px',
    '3xl': '64px',
    '4xl': '96px'
  },
  
  borderRadius: {
    sm: '8px',
    md: '12px',
    lg: '18px',
    xl: '24px',
    full: '9999px',
    button: '26px'
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
  },
  
  transitions: {
    fast: '150ms ease',
    base: '250ms ease',
    slow: '350ms ease'
  },
  
  breakpoints: {
    mobile: '0px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1280px'
  }
};

export type Theme = typeof theme;